import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ListaServicosResponse } from '../../responses/servico/lista-servicos.response';
import { ServicoResponse } from '../../responses/servico/servico.response';
import { ReturnStruct } from '../../structs/return.struct';
import { ServicoListaRequest } from '../../requests/servico/servico-lista.request';
import { ServicoRequest } from '../../requests/servico/servico.request';
import { ExcluirServicosMassaRequest } from '../../requests/servico/excluir-servicos-massa.request';

@Injectable({ providedIn: 'root' })
export class ServicoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiServico + 'Servico';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(request: ServicoListaRequest, paginaAtual: number): Observable<ListaServicosResponse> {
        let params = new HttpParams()
            .set('paginaAtual', paginaAtual.toString())
            .set('tamanhoPagina', '20');

        if (request.pesquisa) {
            params = params.set('pesquisa', request.pesquisa);
        }

        return this.httpClient.get<ListaServicosResponse>(`${this.apiUrl}/all`, {
            params: params,
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public getById(idServico: number): Observable<ServicoResponse> {
        return this.httpClient.get<ServicoResponse>(`${this.apiUrl}/idServico/${idServico}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public post(request: ServicoRequest): Observable<ReturnStruct> {
        return this.httpClient.post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(idServico: number, request: ServicoRequest): Observable<ReturnStruct> {
        return this.httpClient.put<ReturnStruct>(`${this.apiUrl}/idServico/${idServico}`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(idServico: number): Observable<ReturnStruct> {
        return this.httpClient.delete<ReturnStruct>(`${this.apiUrl}/idServico/${idServico}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public excluirEmMassa(request: ExcluirServicosMassaRequest): Observable<ReturnStruct> {
        return this.httpClient.post<ReturnStruct>(`${this.apiUrl}/excluir-em-massa`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
